import { createSlice } from '@reduxjs/toolkit';
import { createComplaint } from './actions';

const initialState = {
  data: null,
  isLoading: false,
  error: null,
  hasLoaded: false,
};

const errorMessage = (action) =>
  action.payload?.message ?? action.error?.message ?? 'Failed to create complaint';

const createComplaintSlice = createSlice({
  name: 'createComplaint',
  initialState,
  reducers: {
    clearCreateComplaintError: (state) => {
      state.error = null;
    },
    resetCreateComplaintState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createComplaint.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.hasLoaded = false;
      })
      .addCase(createComplaint.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasLoaded = true;
        state.data = action.payload?.data ?? action.payload;
      })
      .addCase(createComplaint.rejected, (state, action) => {
        if (action.meta.aborted) return;
        state.isLoading = false;
        state.hasLoaded = true;
        state.error = errorMessage(action);
      });
  },
});

export const { clearCreateComplaintError, resetCreateComplaintState } =
  createComplaintSlice.actions;
export default createComplaintSlice.reducer;
